module.exports = __webpack_public_path__ + "static/media/white-logo.8ea62112.svg";